import React, { Component } from 'react'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import { RempeHeader } from '@modules/admin/Rempe.Header'
import ProfessionalForm from '@modules/admin/professionals/Professional.Form'
import { Loading } from '@modules/core/components/Loading'
import { Trans, withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import Consultations from '@services/Consultations'

class UpdateProfessional extends Component {
  clientProfessional = Consultations.professional

  state = {
    professional: undefined,
    isFetching: false,
    professionalRoles: [],
    professionalCheckEp: '',
    professionalUpdate: '',
    professionalExistsEp: false,
    companiesReceipt: 0,
  }

  checkEpData = async () => {
    const response = await Consultations.professionalCheckEp.show(this.props.match.params.id)

    if (!response['user_exists']) {
      this.setState({ professionalCheckEp: 'El profesional no tiene registro en "electronic prescription"' })
    } else if (response['user_exists'] && Object.keys(response['can_receipt']).length === 0) {
      this.setState({
        professionalCheckEp: 'El profesional tiene registro en "electronic prescription" pero no puede recetar',
      })
      this.setState({ professionalExistsEp: true })
      this.setState({ companiesReceipt: Object.keys(response['can_receipt']).length })
    } else {
      this.setState({
        professionalCheckEp:
          'El profesional puede recetar en las siguientes compañías ' +
          Object.values(response['can_receipt']).toString(),
      })
      this.setState({ professionalExistsEp: true })
    }
  }

  resolveInconsistencies = async () => {
    await Consultations.professionalUpdate.show(this.props.match.params.id)

    this.setState({ professionalCheckEp: 'Petición enviada con éxito' })
    this.setState({ professionalExistsEp: true })
  }

  componentDidMount() {
    this.checkEpData()
    const professionalId = this.props.match.params.id
    this.setState({ isFetching: true })

    this.fetchProfessionalRoles()
    return this.clientProfessional
      .show(professionalId)
      .then((res) => {
        //TODO: Move the mapping logic of the translation languages to ProfessionalFormComponent
        res.data.translations = res.data.translations.map((translation) => ({
          ...translation,
          language: { iso_code: translation.locale, name: translation.language_name },
        }))
        return this.setState({
          professional: { ...res.data, phone: { phone: res.data.phone || '' } },
          isFetching: false,
        })
      })
      .catch((err) =>
        this.setState(undefined, () => {
          throw err
        })
      )
  }

  fetchProfessionalRoles = async () => {
    try {
      const response = await Consultations.professionalRoles.index()
      this.setState({ professionalRoles: response.data })
    } catch (e) {
      console.error(e.message)
    }
  }

  render() {
    const { professionalRoles, professional } = this.state
    return (
      <div className="crud-wrapper professional-wrapper">
        <div className="professional-update">
          <DashboardHeader title={<Trans>Editar Profesional</Trans>}>
            <Link className="btn btn-primary" to={`/professional`}>
              <Trans>Volver</Trans>
            </Link>
          </DashboardHeader>

          {this.state.professionalExistsEp === false && (
            <RempeHeader title={this.state.professionalCheckEp}>
              <button
                className="btn btn-primary rempe_resolve_inconsistencies"
                onClick={() => this.resolveInconsistencies()}
              >
                <Trans>Resolver</Trans>
              </button>
            </RempeHeader>
          )}

          {this.state.professionalExistsEp === true && (
            <RempeHeader title={this.state.professionalCheckEp}></RempeHeader>
          )}

          <Loading isFetching={this.state.isFetching} />
          <div className="container-fluid main-content">
            {professional && <ProfessionalForm initialValues={professional} professionalRoles={professionalRoles} />}
          </div>
        </div>
      </div>
    )
  }
}
export default withTranslation()(UpdateProfessional)
